// Copyright (c) 2019 Deere & Company

import { combineReducers } from 'redux';
import { getApplicationReducers } from './app/common/application-reducer';
import { getCombinedReducers as getCombinedOktaStateReducers } from './okta-state/reducers';

export default () => combineReducers( {
    application: getApplicationReducers(),
    oktaState: getCombinedOktaStateReducers(),
} );
